import React from "react";

const CustomerAdvertisingAgentAgreement = () => {
  return (
    <section
      id="customer_advertising_agent_agreement"
      className="ico_about_section section_space section_decoration bg-white"
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">TOPCOIN UK LTD</h5>
            <p className="text-dark opacity-75">
              <strong>
                CUSTOMER ADVERTISING M AGENT &amp; SENIOR ADVERTISING AGENT
                AGREEMENT
              </strong>
            </p>

            <h5 className="title_text text-dark">Agent Participation Notice</h5>
            <p className="text-dark opacity-75">
              Members who wish to participate as a Customer Advertising M Agent
              or Senior Advertising Agent and be eligible to receive TopCoin
              recognition settlement as described in Clause 8 of this Agreement
              must carefully read and accept this Agreement before participating
              as an agent within the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Participation as an agent and eligibility for settlement of TopCoin
              recognition are only available to members who accept the terms of
              this Agreement through the platform registration process.
            </p>

            <h5 className="title_text text-dark">
              Refer Once — Recognition Continues While the Customer Uses the
              Platform
            </h5>

            <h5 className="title_text text-dark">Platform Growth Principle</h5>
            <p className="text-dark opacity-75">
              TopCoin UK grows through customer participation. Members who
              introduce new customers help expand the platform community and may
              receive TopCoin recognition linked to activity generated within the
              platform network, according to the operational rules of the TopCoin
              UK platform.
            </p>

            <h5 className="title_text text-dark">Network Growth Principle</h5>
            <p className="text-dark opacity-75">
              Every customer introduced to the TopCoin platform becomes part of
              the introducing agent’s network.
            </p>
            <p className="text-dark opacity-75">
              As those customers continue to participate in the platform, the
              agent’s network may continue to grow alongside the platform.
            </p>

            <h5 className="title_text text-dark">1. Platform Purpose</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd operates as an Advertising &amp; Loyalty Platform
              connecting customers with participating businesses.
            </p>
            <p className="text-dark opacity-75">
              The platform enables customers to collect TopCoin loyalty
              recognition linked to participation and shopping activity with
              participating retailers.
            </p>
            <p className="text-dark opacity-75">
              TopCoin represents platform loyalty recognition only and does not
              represent:
            </p>
            <ul>
              <li className="text-dark opacity-75">Money</li>
              <li className="text-dark opacity-75">A financial investment</li>
              <li className="text-dark opacity-75">A savings product</li>
              <li className="text-dark opacity-75">
                A guaranteed financial return
              </li>
            </ul>

            <h5 className="title_text text-dark">2. Customer Membership</h5>
            <p className="text-dark opacity-75">
              Any individual may join the TopCoin UK platform free of charge.
            </p>
            <p className="text-dark opacity-75">Members may:</p>
            <ul>
              <li className="text-dark opacity-75">
                Participate in the TopCoin platform
              </li>
              <li className="text-dark opacity-75">
                Collect TopCoin recognition through platform activity
              </li>
              <li className="text-dark opacity-75">
                Introduce other customers to the platform
              </li>
              <li className="text-dark opacity-75">
                Apply to participate as a Customer Advertising M Agent
              </li>
            </ul>

            <h5 className="title_text text-dark">
              3. Customer Advertising M Agent Role
            </h5>
            <p className="text-dark opacity-75">
              A registered member may apply to participate as a Customer
              Advertising M Agent.
            </p>
            <p className="text-dark opacity-75">
              Customer Advertising M Agents support the growth of the platform
              by:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Introducing new customers to the TopCoin platform
              </li>
              <li className="text-dark opacity-75">
                Promoting awareness of the TopCoin platform
              </li>
              <li className="text-dark opacity-75">
                Supporting the expansion of the customer community
              </li>
            </ul>
            <p className="text-dark opacity-75">
              Customer Advertising M Agents operate independently and are not
              employees, partners, or representatives of TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">
              4. TopCoin Recognition for M Agents
            </h5>
            <p className="text-dark opacity-75">
              Where customers introduced by a Customer Advertising M Agent
              participate in the platform and collect TopCoin through genuine
              platform activity, the M Agent may receive TopCoin recognition
              linked to that activity according to the operational rules of the
              platform.
            </p>
            <p className="text-dark opacity-75">
              Recognition remains linked to platform participation, not
              recruitment itself.
            </p>

            <h5 className="title_text text-dark">
              5. Referred Customer Activity Recognition
            </h5>
            <p className="text-dark opacity-75">
              When a Customer Advertising M Agent introduces a new customer to
              the TopCoin platform, the introduction is recorded by the platform
              system.
            </p>
            <p className="text-dark opacity-75">
              If the referred customer participates in the platform and collects
              TopCoin through normal activity, the introducing M Agent may
              receive TopCoin recognition linked to that activity.
            </p>
            <p className="text-dark opacity-75">
              A customer only needs to be referred once, and recognition may
              continue while the customer remains active in the platform.
            </p>

            <h5 className="title_text text-dark">
              6. Eligibility for Senior Advertising Agent Status
            </h5>
            <p className="text-dark opacity-75">
              A Customer Advertising M Agent may become eligible for recognition
              as a Senior Advertising Agent after introducing a minimum of 1,000
              active customers to the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Eligibility remains subject to review and approval by TopCoin UK
              Ltd.
            </p>

            <h5 className="title_text text-dark">7. Senior Advertising Agent Role</h5>
            <p className="text-dark opacity-75">
              Senior Advertising Agents support the development and growth of the
              TopCoin customer network by:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Supporting and guiding Customer Advertising M Agents
              </li>
              <li className="text-dark opacity-75">
                Promoting the TopCoin platform
              </li>
              <li className="text-dark opacity-75">
                Encouraging responsible growth of the customer network
              </li>
            </ul>

            <h5 className="title_text text-dark">8. Agent Recognition Settlement</h5>
            <p className="text-dark opacity-75">
              TopCoin recorded through agent participation represents platform
              recognition linked to platform activity.
            </p>
            <p className="text-dark opacity-75">
              Agents may accumulate TopCoin based on activity generated through
              the platform network.
            </p>
            <p className="text-dark opacity-75">
              Where applicable and subject to platform operational rules, agents
              may request settlement of recorded TopCoin balances through TopCoin
              UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Agents participate independently and remain responsible for their
              own tax or regulatory obligations where applicable.
            </p>

            <h5 className="title_text text-dark">9. Retail Agent Participation</h5>
            <p className="text-dark opacity-75">
              Members participating in the advertising structure may also apply
              to participate in the Retail Department of the platform.
            </p>
            <p className="text-dark opacity-75">
              Through the Retail Department members may apply to become:
            </p>
            <ul>
              <li className="text-dark opacity-75">Retail M Agent</li>
              <li className="text-dark opacity-75">Senior Retail Agent</li>
            </ul>
            <p className="text-dark opacity-75">
              Retail participation may be governed by separate retail
              participation agreements.
            </p>

            <h5 className="title_text text-dark">10. Conduct &amp; Compliance</h5>
            <p className="text-dark opacity-75">
              Agents must promote the platform responsibly and must not:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Present TopCoin as an investment opportunity
              </li>
              <li className="text-dark opacity-75">
                Guarantee income or financial returns
              </li>
              <li className="text-dark opacity-75">
                Misrepresent the TopCoin platform or loyalty system
              </li>
            </ul>
            <p className="text-dark opacity-75">
              Failure to comply may result in suspension or removal from the
              platform.
            </p>

            <h5 className="title_text text-dark">11. Independent Participation</h5>
            <p className="text-dark opacity-75">Agents participate independently.</p>
            <p className="text-dark opacity-75">Nothing in this Agreement creates:</p>
            <ul>
              <li className="text-dark opacity-75">Employment</li>
              <li className="text-dark opacity-75">Partnership</li>
              <li className="text-dark opacity-75">Joint venture</li>
              <li className="text-dark opacity-75">
                Authority to legally bind TopCoin UK Ltd
              </li>
            </ul>

            <h5 className="title_text text-dark">12. Brand Protection</h5>
            <p className="text-dark opacity-75">
              All TopCoin branding, platform systems, technology, and operational
              structure remain the property of TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Agents may not copy, replicate, or misuse the platform or brand.
            </p>

            <h5 className="title_text text-dark">13. Confidential Information</h5>
            <p className="text-dark opacity-75">
              Information relating to the TopCoin platform, systems, technology,
              and operations is confidential and may not be disclosed or used
              outside the platform without permission.
            </p>

            <h5 className="title_text text-dark">14. International Participation</h5>
            <p className="text-dark opacity-75">
              Agents operating outside the United Kingdom are responsible for
              complying with laws and regulations within their own jurisdiction.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd accepts no responsibility for local regulatory
              requirements in other countries.
            </p>

            <h5 className="title_text text-dark">15. Limitation of Liability</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd shall not be liable for actions, statements, or
              promotions conducted independently by agents.
            </p>
            <p className="text-dark opacity-75">
              Agents remain responsible for their own conduct.
            </p>

            <h5 className="title_text text-dark">16. Platform Discretion</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd reserves the right to update, modify, or adjust
              platform operational rules, recognition structures, and system
              functions where necessary to maintain the stability and
              development of the platform.
            </p>

            <h5 className="title_text text-dark">17. Platform Termination</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd may suspend or terminate an agent’s participation
              where necessary to protect the platform, brand, or community.
            </p>

            <h5 className="title_text text-dark">
              18. Platform Network Ownership — Advertising Agents
            </h5>
            <p className="text-dark opacity-75">
              All customers introduced to the TopCoin UK platform become
              participants within the TopCoin UK platform network.
            </p>
            <p className="text-dark opacity-75">
              Agents do not obtain ownership or exclusive rights over those
              customers.
            </p>
            <p className="text-dark opacity-75">
              Customers participate directly within the platform under the
              TopCoin UK operational rules.
            </p>

            <h5 className="title_text text-dark">
              19. No Lifetime Rights or Ownership Claims
            </h5>
            <p className="text-dark opacity-75">
              Participation as a Customer Advertising M Agent or Senior
              Advertising Agent does not grant permanent or lifetime rights over
              customers introduced to the platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin recognition linked to platform activity may only continue
              while the agent remains an active participant and while the
              platform rules permit such recognition.
            </p>

            <h5 className="title_text text-dark">20. Governing Law</h5>
            <p className="text-dark opacity-75">
              This Agreement shall be governed by the laws of England and Wales.
            </p>

            <p className="text-dark opacity-75 mt-4">
              <strong>TopCoin UK Ltd</strong>
              <br />
              Advertising &amp; Loyalty Platform
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerAdvertisingAgentAgreement;

